export default __webpack_public_path__ + "static/media/LElogo.99ac6fe7.png";